import { render } from "./popover.md?vue&type=template&id=7ca44c36"
import script from "./popover.md?vue&type=script&lang=js"
export * from "./popover.md?vue&type=script&lang=js"
script.render = render

export default script